import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import DebugService from '../services/DebugService';
import {
  Tab,
  TextField
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import APIConstants from '../services/APIConstants';
import InventoryApiService from '../services/InventoryApiService';
import './common/Styles.css'
import SnackbarNotification, { SNACKBAR_THEME } from './common/SnackbarNotification';
import DataGridTable from './common/DataGridTable';
import { asgColumnsForInventoryReports, ec2ColumnsForInventoryReports, rdsColumnsForInventoryReports, tagColumnsForInventoryReports } from '../services/InventoryService';
import { FaBullseye } from 'react-icons/fa6';
import TableLoader from './common/contentloader/TableLoader';
import { BlockContainer } from './common/BlockContainer';
import dayjs from 'dayjs';
import { useAuth } from '../state/AuthContext';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { CONST_SITE_LABEL, setScopedItem, STORAGE_KEYS } from './common/Helper';

export default function InventoryReports() {
  // Start date should be 10 days ago
  const [changesDate, setChangesDate] = useState();
  const [changestoDate, setChangestoDate] = useState(); // End date should be yesterday
  const [ec2Data, setEC2Data] = useState([])
  const [rdsData, setRDSData] = useState([])
  const [asgData, setASGData] = useState([])
  const [tagData, setTagData] = useState([])
  const [showSnackbarMessage, setShowSnackbarMessage] = useState('HIDE')
  const [showLoader, setShowLoader] = useState(FaBullseye);
  const [ec2TotalSavingCost, setEC2TotalSavingCost] = useState(0);
  const [rdsTotalSavingCost, setRDSTotalSavingCost] = useState(0)
  const [asgTotalSavingCost, setASGTotalSavingCost] = useState(0)
  const [tagTotalSavingCost, setTagTotalSavingCost] = useState(0)
  const [selectedTab, setSelectedTab] = useState('EC2')

  const [inventoryApiData, setInventoryApiData] = useState(null)
  const { selectedAccount } = useAuth()

  useEffect(() => {
    const fetchData = async () => {

      setShowSnackbarMessage('HIDE')
      setEC2TotalSavingCost(0)
      setRDSTotalSavingCost(0)
      setASGTotalSavingCost(0)
      setTagTotalSavingCost(0)
      setShowLoader(true)

      if (changesDate && changestoDate) {
        const dateRequestBody = {
          userAccountId: selectedAccount ?? '',
          fromDate: changesDate,
          toDate: changestoDate
        }

        try {
          // setloading(true)
          const [ec2Res, rdsRes, asgRes, tagRes] = await Promise.all([
            InventoryApiService.getAllSavingCost(APIConstants.ENDPOINT_INVENTORY_EC2_ALL_EVENT_COST, dateRequestBody),
            InventoryApiService.getAllSavingCost(APIConstants.ENDPOINT_INVENTORY_RDS_ALL_EVENT_COST, dateRequestBody),
            InventoryApiService.getAllSavingCost(APIConstants.ENDPOINT_INVENTORY_ASG_ALL_EVENT_COST, dateRequestBody),
            InventoryApiService.getAllSavingCost(APIConstants.ENDPOINT_INVENTORY_TAG_ALL_EVENT_COST, dateRequestBody)
          ])

          DebugService.log(`Inventory Report Component: Api Response`, ec2Res, rdsRes, asgRes)

          const ec2Instances = ec2Res['data'] ?? []
          const rdsInstances = rdsRes['data'] ?? []
          const asgInstances = asgRes['data'] ?? []
          const tagInstances = tagRes['data'] ?? []

          setInventoryApiData({
            ec2Instances: ec2Res?.data ? ec2Res : {},
            rdsInstances: rdsRes?.data ? rdsRes : {},
            asgInstances: asgRes?.data ? asgRes : {},
            tagInstances: tagRes?.data ? tagRes : {},
          });

          if (!ec2Res['data'] && !rdsRes['data'] && !asgRes['data'] && !tagRes['data']) {
            setShowSnackbarMessage('SHOW')
          }

          setEC2Data(prev => ec2Instances.map(i => {
            return {
              ...i,
              id: i['instanceId'],
              totalSavingCost: `$${(i['totalSavingCost'] ?? 0).toFixed(2)}`,
              onDemandPriceValue: `$${(i['onDemandPriceValue'] ?? 0).toFixed(3)}`
            }
          }))

          setTagData(prev => tagInstances.map(i => {
            return {
              ...i,
              id: i['instanceId'],
              totalSavingCost: `$${(i['totalSavingCost'] ?? 0).toFixed(2)}`,
              onDemandPriceValue: `$${(i['onDemandPriceValue'] ?? 0).toFixed(3)}`
            }
          }))

          setRDSData(prev => rdsInstances.map(i => {
            let totalOnDemandPrice = 0

            if (i['RDSType'] === 'DBInstanceIdentifiers') {
              totalOnDemandPrice = i['costingDetails'][0]['onDemandPriceValue']
            } else {
              for (let x = 0; x < i['costingDetails'].length; x++) {
                totalOnDemandPrice += i['costingDetails'][x]['onDemandPriceValue']
              }
            }

            return {
              ...i,
              // id: i['instanceId'],
              totalSavingCost: `$${(i['totalSavingCost'] ?? 0).toFixed(2)}`,
              totalOnDemandPriceValue: (totalOnDemandPrice).toFixed(3)
              // onDemandPriceValue: `$${i['onDemandPriceValue'].toFixed(2)}`
            }
          }))

          setASGData(prev => asgInstances.map(i => {
            return {
              ...i,
              id: i['instanceId'],
              totalSavingCost: `$${(i['totalSavingCost'] ?? 0).toFixed(2)}`,
              totalOnDemandPriceValue: 0
              // onDemandPriceValue: `$${i['onDemandPriceValue'].toFixed(2)}`
            }
          }))

          if (ec2Res['totalSaving']) {
            setEC2TotalSavingCost(prev => ec2Res['totalSaving'])
          } else {
            if (ec2Instances.length > 0) {
              let ec2SavingsSum = 0.00
              ec2Instances.forEach(i => {
                ec2SavingsSum = ec2SavingsSum + i['totalSavingCost']
              })

              setEC2TotalSavingCost(prev => ec2SavingsSum)
            }
          }

          if (tagRes['totalSaving']) {
            setTagTotalSavingCost(prev => tagRes['totalSaving'])
          } else {
            if (tagInstances.length > 0) {
              let tagSavingsSum = 0.00
              tagInstances.forEach(i => {
                tagSavingsSum = tagSavingsSum + i['totalSavingCost']
              })
              setTagTotalSavingCost(prev => tagSavingsSum)
            }
          }

          if (rdsRes['totalSaving']) {
            setRDSTotalSavingCost(prev => rdsRes['totalSaving'])
          } else {
            if (rdsInstances.length > 0) {

              let rdsSavingsSum = 0
              rdsInstances.forEach(i => {
                rdsSavingsSum = rdsSavingsSum + i['totalSavingCost']
              })

              setRDSTotalSavingCost(prev => rdsSavingsSum)
            }
          }

          if (asgRes['totalSaving']) {
            setASGTotalSavingCost(prev => asgRes['totalSaving'])
          } else {
            if (asgInstances.length > 0) {

              let asgSavingsSum = 0
              asgInstances.forEach(i => {
                asgSavingsSum = asgSavingsSum + i['totalSavingCost']
              })

              setASGTotalSavingCost(prev => asgInstances)
            }
          }

          setShowLoader(false)

        } catch (error) {
          DebugService.error('Inventory Report Component: Error caught while fetching data', error)
          setShowLoader(false)
        } finally {
          // setloading(false)
        }

      } else {
        // TODO Snackbar date selection error
        setShowLoader(false)
      }
    };

    fetchData();
    // Fetch instance details based on instanceDetails from the store

  }, [changestoDate, changesDate, selectedAccount]);

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Inventory Reports`

    // Set default date
    const today = new Date()
    const currentYr = today.getFullYear()
    const currentMonth = today.getMonth()
    setChangesDate(dayjs(new Date(currentYr, currentMonth, 1)))
    setChangestoDate(dayjs(new Date(currentYr, currentMonth + 1, 0)))
  }, [])

  /**
  * @description Stores the latest API response in storage.
  * @author Ashish Sharma
  */
  useEffect(() => {
    setScopedItem(STORAGE_KEYS.AI_CHATBOT_REQUEST_DATA, inventoryApiData);
  }, [inventoryApiData]);

  return (
    <Grid container spacing={3} className='inventory-reports-page'>

      {/* Filters */}
      <Grid item xs={12} md={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DateTimePicker']}>
            <DemoItem label="From Date">
              <DatePicker
                value={changesDate} // Set start date and time
                onChange={(newDate) => setChangesDate(newDate)}
                slots={{
                  textField: (props) => (
                    <TextField {...props} variant="outlined" margin="normal" fullWidth />
                  )
                }}
                format="DD/MM/YYYY"
              />
            </DemoItem>
          </DemoContainer>
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={6}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DateTimePicker']}>
            <DemoItem label="To Date">
              <DatePicker
                value={changestoDate} // Set end date and time
                onChange={(newDate) => setChangestoDate(newDate)}
                slots={{
                  textField: (props) => (
                    <TextField {...props} variant="outlined" margin="normal" fullWidth />
                  )
                }}
                format="DD/MM/YYYY"
              />
            </DemoItem>
          </DemoContainer>
        </LocalizationProvider>
      </Grid>

      {/* Summary Blocks */}
      <Grid item xs={12} md>
        <BlockContainer
          order={1}
          displayValue={ec2TotalSavingCost.toFixed(2)}
          displayLabel={'EC2 Total Savings'}
          displayBGColor={'#D7BDE2'}
          unitValue={'$'}
        />
      </Grid>
      <Grid item xs={12} md>
        <BlockContainer
          order={2}
          displayValue={rdsTotalSavingCost.toFixed(2)}
          displayLabel={'RDS Total Savings'}
          unitValue={'$'}
        />
      </Grid>
      <Grid item xs={12} md>
        <BlockContainer
          order={3}
          displayValue={asgTotalSavingCost.toFixed(2)}
          displayLabel={'ASG Total Savings'}
          unitValue={'$'}
        />
      </Grid>
      <Grid item xs={12} md>
        <BlockContainer
          order={4}
          displayValue={tagTotalSavingCost.toFixed(2)}
          displayLabel={'Tag Total Savings'}
          unitValue={'$'}
        />
      </Grid>
      <Grid item xs={12} md>
        <BlockContainer
          order={5}
          displayValue={(ec2TotalSavingCost + rdsTotalSavingCost + asgTotalSavingCost + tagTotalSavingCost).toFixed(2)}
          displayLabel={'Total Savings'}
          unitValue={'$'}
        />
      </Grid>

      <Grid item xs={12}>
        <TabContext value={selectedTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(e, currentTab) => setSelectedTab(currentTab)} aria-label="Inventory Reports Tab">
              <Tab label="EC2" value="EC2" className='tab' />
              <Tab label="RDS" value="RDS" className='tab' />
              <Tab label="ASG" value="ASG" className='tab' />
              <Tab label="Tag" value="TAG" className='tab' />
            </TabList>
          </Box>
          <TabPanel value="EC2" className='tab-panel'>
            {showLoader && <TableLoader />}
            {!showLoader && <Grid item xs={12} md={12} lg={12}>
              <DataGridTable
                evenRowBgColor={''}
                headerBgColor={'#506C84'}
                actionIconColor={'#506C84'}
                evenRowColor={'#506C84'}
                columns={ec2ColumnsForInventoryReports}
                rows={ec2Data}
                showTooltip={true}
                showPagination={true}
              />
            </Grid>
            }
          </TabPanel>

          <TabPanel value="RDS" className='tab-panel'>
            {showLoader && <TableLoader />}
            {!showLoader && <Grid item xs={12} md={12} lg={12}>
              <DataGridTable
                evenRowBgColor={''}
                headerBgColor={'#506C84'}
                actionIconColor={'#506C84'}
                evenRowColor={'#506C84'}
                columns={rdsColumnsForInventoryReports}
                rows={rdsData}
                showTooltip={true}
                showPagination={true}
              />
            </Grid>
            }
          </TabPanel>

          <TabPanel value="ASG" className='tab-panel'>
            {showLoader && <TableLoader />}
            {!showLoader && <Grid item xs={12} md={12} lg={12}>
              <DataGridTable
                evenRowBgColor={''}
                headerBgColor={'#506C84'}
                actionIconColor={'#506C84'}
                evenRowColor={'#506C84'}
                columns={asgColumnsForInventoryReports}
                rows={asgData}
                showTooltip={true}
                showPagination={true}
              />
            </Grid>
            }
          </TabPanel>

          <TabPanel value="TAG" className='tab-panel'>
            {showLoader && <TableLoader />}
            {!showLoader && <Grid item xs={12} md={12} lg={12}>
              <DataGridTable
                evenRowBgColor={''}
                headerBgColor={'#506C84'}
                actionIconColor={'#506C84'}
                evenRowColor={'#506C84'}
                columns={tagColumnsForInventoryReports}
                rows={tagData}
                showTooltip={true}
                showPagination={true}
              />
            </Grid>
            }
          </TabPanel>
        </TabContext>
      </Grid>

      {showSnackbarMessage === 'SHOW' && <SnackbarNotification
        initialOpen={true}
        duration={7000}
        message={'No instances found for the selected date'}
        actionButtonName={'Ok'}
        theme={SNACKBAR_THEME.RED}
        yPosition={'top'}
        xPosition={'center'}
      />
      }
    </Grid>
  )
}
